import { render, staticRenderFns } from "./Passquery.vue?vue&type=template&id=6df6ae64&scoped=true"
import script from "./Passquery.vue?vue&type=script&lang=js"
export * from "./Passquery.vue?vue&type=script&lang=js"
import style0 from "./Passquery.vue?vue&type=style&index=0&id=6df6ae64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6ae64",
  null
  
)

export default component.exports